import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/TermsPage/TermsPage.tsx");
